import React, { FC, ReactNode } from "react";
import { LDProvider } from "launchdarkly-react-client-sdk";
import { authorizationService } from "shared-auth";
import { buildUser } from "./utils";
import config from "../../config";

type LaunchDarklyProviderProps = {
  children: ReactNode;
};

const LaunchDarklyProvider: FC<
  React.PropsWithChildren<LaunchDarklyProviderProps>
> = ({ children }) => {
  const user = authorizationService.getUserFromStore();

  return (
    <LDProvider
      clientSideID={config.launchDarkly.clientSideID}
      context={{
        kind: "user",
        ...buildUser(user),
      }}
      reactOptions={{
        useCamelCaseFlagKeys: false,
      }}
    >
      {children}
    </LDProvider>
  );
};

export default LaunchDarklyProvider;
